<div *ngIf="modalArguments" data-test-id="modal-default" class="modal-window">
  <div class="modal-header">
    <h4 class="modal-title" data-test-id="modal-title">
      {{ modalArguments.title }}
    </h4>
    <button
      type="button"
      class="unstyled-button"
      aria-label="Close"
      data-test-id="modal-btn-dismiss"
      (click)="onDismiss()"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
    </button>
  </div>
  <div class="modal-body" data-test-id="wrap-request">
    <input data-test-id="email-input" class="form-control" type="search" [value]="modalArguments.email" readonly />
    <textarea
      class="form-control"
      data-test-id="request-input"
      [formControl]="requestDescription"
      [ngClass]="{
        invalid: !isValid && requestDescription.value.length > 0
      }"
      (blur)="onBlur()"
      type="search"
      placeholder="Write message"
      rows="5"
    ></textarea>
    <div class="float-end">
      <app-counter
        [maxLength]="maxReasonLength"
        [dataTestId]="'dialog-admin'"
        [isFieldInvalid]="requestDescription.value.length > maxReasonLength"
        [valueLength]="requestDescription.value.length"
      >
      </app-counter>
    </div>
    <p>{{ 'DEACTIVATED_REQUIRED_FIELD' | translate }}</p>
  </div>
  <div class="modal-footer" data-test-id="modal-footer">
    <button
      *ngFor="let button of modalArguments.buttons; index as i"
      [attr.type]="button.type || 'button'"
      class="btn"
      [ngClass]="button.class"
      (click)="actionsHandler(button.action)"
      [attr.data-test-id]="'modal-btn-' + button.action"
      [disabled]="button.action === confirmActionButton && !isValid"
    >
      {{ button.text | translate }}
    </button>
  </div>
</div>
